import React, { useMemo } from 'react';
import { ProfileSelectionGrid } from '../ProfileSelectionGrid/ProfileSelectionGrid.tsx';
/** Avatar grid for the edit profile dialog. */ export const EditProfileAvatarSelector = ({ avatars, selectedAvatar, onAvatarSelect, onDisabledAvatarSelect })=>{
    const options = useMemo(()=>avatars.map((avatar)=>({
                id: avatar.avatarId,
                name: avatar.name,
                imageUrl: avatar.imageUrl,
                disabled: avatar.disabled
            })), [
        avatars
    ]);
    return /*#__PURE__*/ React.createElement(ProfileSelectionGrid, {
        options: options,
        selectedId: selectedAvatar,
        onSelect: onAvatarSelect,
        onDisabledSelect: onDisabledAvatarSelect
    });
};
